<template>
  <v-flex class="accountMandates" data-qa="accountmandates-flex-j62pre">
    <v-layout wrap class="ml-2 accountMandates--gradientBGposition" data-qa="accountmandates-layout-0fa03p">
      <!-- snackbar -->
      <dob-snackbar
        v-if="snackbar.visible"
        :config="{ snackbar }" />

      <v-flex xs12 sm12 md12 lg12 xl12 :style="{ background: dashboardGradient, height: '180px' }" data-qa="accountmandates-flex-cnfans">
        <v-container class="accountMandates--title-padding" data-qa="accountmandates-container-klrjqa">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="accountmandates-flex-r3lvqj">
            <v-row no-gutters data-qa="accountmandates-row-c0t0k">
              <v-layout row wrap class="pb-2 pl-12" data-qa="accountmandates-layout-yvuoik">
                <div class="pt-3" data-qa="accountmandates-div-o7ci1p">
                  <v-avatar :tile="false" size="35" color="white" data-qa="accountmandates-avatar-1g8mzs">
                    <v-icon :color="primaryColor" data-qa="accountmandates-icon-zok9pp">mdi-account-cog-outline</v-icon>
                  </v-avatar>
                </div>
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="accountmandates-flex-528zr5">
                  <v-row no-gutters data-qa="accountmandates-row-mm86i">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("accountMandates.title")}}
                    </font>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg12 xl12 class="accountMandates--content-padding accountMandates--overlayCardFlex" data-qa="accountmandates-flex-nqh2j8m">
      <v-layout row wrap class="accountMandates--content-padding" data-qa="accountmandates-layout-rsc8zl">
        <v-flex xs12 sm11 md10 lg9 xl10 class="pt-4" data-qa="accountmandates-flex-rewsfr">
          <v-card data-qa="accountmandates-card-vd0bak">

            <add-payment-mandate
                v-if="showAddPaymentMandate"
                @close="showAddPaymentMandate=false"
                @addMandateData="receiveData"
                :config="{ mandatesInfo }" />

            <v-container data-qa="accountmandates-container-41qxz9">
              <v-row no-gutters align="center" data-qa="accountmandates-row-ic1e76">
                <v-col sm="12" md="12" lg="4" data-qa="accountmandates-col-w0zihf">
                  <v-autocomplete data-qa="accountType" v-model="selectedAccountNumber" :items="accountList"
                    :color="primaryColor" attach @change="accountChange" append-icon="mdi-chevron-down" outlined
                    background-color="#f0eff7" :label="this.$t('accountMandates.label.accountSelect')" class="pt-4 pl-2"
                    return-object>
                    <template v-slot:prepend-inner>
                      <span data-qa="accountmandates-span-iydc5e">
                        <v-icon :color="primaryColor" data-qa="accountmandates-icon-g31t7m">
                          mdi-account-box-outline
                        </v-icon>
                      </span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col sm="11" md="11" lg="7" v-if="isAccountSelected" data-qa="accountmandates-col-8zlm9a">
                  <v-row no-gutters data-qa="accountmandates-row-ah1v26">
                    <v-col sm="12" md="12" lg="4" data-qa="accountmandates-col-7oqr0u">
                      <font style="padding-left: 10px;" color="#C137A2" class="font-weight-bold" size="3"> {{ $t('accountMandates.label.noMandates') }} </font>
                    </v-col>
                    <v-col sm="12" md="12" lg="8" data-qa="accountmandates-col-5ek8te">
                      <v-radio-group row v-model="mandateRequiredFlag" @change="setFlowValues()" class="small-radio" data-qa="accountmandates-radio-group-typ4t">
                        <v-radio :label="this.$t('accountMandates.button.allowPayment')" style="padding-left: 16px;" color="#C137A2" value="N" class="pl-2" data-qa="accountmandates-radio-lmfdrc"></v-radio>
                        <v-radio :label="this.$t('accountMandates.button.restrictPayment')" style="padding-left: 16px;" color="#C137A2" value="Y" class="pl-2" data-qa="accountmandates-radio-mm1lm"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row no-gutters data-qa="accountmandates-row-85nmyk">
                    <v-col sm="12" md="12" lg="4" data-qa="accountmandates-col-qlyk0a">
                      <font style="padding-left: 10px;" color="#C137A2" class="font-weight-bold" size="3"> {{ $t('accountMandates.label.noApprovers') }} </font>
                    </v-col>
                    <v-col sm="12" md="12" lg="8" data-qa="accountmandates-col-uy5l7">
                      <v-radio-group row v-model="authorizerRequiredFlag" @change="setFlowValues()" class="small-radio" data-qa="accountmandates-radio-group-ybmylp">
                        <v-radio :label="this.$t('accountMandates.button.allowPayment')" style="padding-left: 16px;" color="#C137A2" value="N" class="pl-2" data-qa="accountmandates-radio-f664ej"></v-radio>
                        <v-radio :label="this.$t('accountMandates.button.restrictPayment')" style="padding-left: 16px;" color="#C137A2" value="Y" class="pl-2" data-qa="accountmandates-radio-aqtvjb"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col sm="1" md="1" lg="1" v-if="isAccountSelected" data-qa="accountmandates-col-mjgnvc">
                  <v-tooltip top data-qa="accountmandates-tooltip-vv6lqh">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="py-2 px-4"
                        icon @click="emitSaveFlow()" :disabled="disableSaveBtn"
                       data-qa="accountmandates-btn-tpgss9">
                        <v-avatar :tile="false" size="40" :color="disableSaveBtn ? '#eeeeee': secondaryColor" data-qa="accountmandates-avatar-9kxr4">
                          <v-icon color="white" class="material-symbols-outlined" size="18px" data-qa="accountmandates-icon-at3u1">save</v-icon>
                        </v-avatar>
                      </v-btn>
                    </template>
                    <span data-qa="accountmandates-span-jwlsjd">{{ $t("accountMandates.label.saveDefinition")}}</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-divider data-qa="accountmandates-divider-mxqgmt"  class="pa-1" />

              <!-- Mandates Title -->
              <v-flex xs12 sm12 md12 lg12 xl12 class="pa-4" v-if="isAccountSelected" data-qa="accountmandates-flex-uasi5e">
                <v-row no-gutters data-qa="accountmandates-row-bvcbcg">
                  <v-layout data-qa="accountmandates-layout-kmq4zq">
                    <v-flex data-qa="accountmandates-flex-bedtmh">
                      <font :color="primaryColor" class="font-weight-bold text-h5">
                        {{ $t('accountMandates.label.subtitle') }}
                      </font>
                    </v-flex>
                    <v-flex sm12 xs12 md12 lg12 xl12
                      class="text-right"
                      v-if="selectedAccountNumber"
                     data-qa="accountmandates-flex-5mb265">
                      <template>
                        <v-btn
                         v-if="hasPaymentMandates"
                          :color="primaryColor"
                          @click="addPaymentMandate()"
                          dark
                          class="mb-2 text-capitalize font-weight-bold py-2 px-4"
                         data-qa="accountmandates-btn-0s72z">
                          <v-icon left class="material-symbols-outlined" size="18px" data-qa="accountmandates-icon-nn8t">
                            add
                          </v-icon>
                          {{ $t('accountMandates.button.addBtn') }}
                        </v-btn>
                      </template>
                    </v-flex>
                  </v-layout>
                </v-row>
              </v-flex>

              <!--Data Table -->
              <template>
                <v-data-table
                  v-if="isAccountSelected"
                  :headers="headers"
                  :items="this.mandates.mandateDetails"
                  :items-per-page="10"
                  class="elevation-1"
                  :sort-by="['initiator']"
                  :sort-desc=false
                  :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-page-first',
                    lastIcon: 'mdi-page-last',
                    prevIcon: 'mdi-less-than',
                    nextIcon: 'mdi-greater-than',
                    disableItemsPerPage: !hasPaymentMandates,
                    disablePagination: !hasPaymentMandates
                  }"
                  :hide-default-header="!hasPaymentMandates"
                 data-qa="accountmandates-data-table-5exu3t">
                  <template v-slot:item.initiatorName="{ item }">
                    {{ item.initiatorName }}
                    <br data-qa="accountmandates-br-ic1ewh">
                    <font size="1">{{ item.relationType }}</font>
                  </template>
                  <template v-slot:item.amountRangeFrom="{ item }">
                    {{ formatAmount(item.amountRangeFrom) }}
                  </template>
                  <template v-slot:item.amountRangeTo="{ item }">
                    {{ formatAmount(item.amountRangeTo) }}
                  </template>
                  <!-- Action Buttons -->
                  <template v-slot:item.actions="{ item, index }">
                    <v-icon small class="mr-2 material-symbols-outlined" @click="editItem(item)" :color="primaryColor" size="18px" data-qa="accountmandates-icon-zil3ld">
                      edit
                    </v-icon>
                    <v-icon small class="mr-2 material-symbols-outlined" @click="copy(item)" :color="primaryColor" size="18px" data-qa="accountmandates-icon-4irlv">
                      content_copy
                    </v-icon>

                    <v-menu
                      v-model="menu[index]"
                      top
                      nudge-left="90"
                      nudge-top="10"
                      offset-y data-qa="accountmandates-menu-iqv98l">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          :color="menu[index] ? 'red' : primaryColor"
                          v-bind="attrs"
                          v-on="on"
                          class="material-symbols-outlined"
                          size="18px"
                         data-qa="accountmandates-icon-3g5v2o">
                          delete
                        </v-icon>
                      </template>
                      <v-card class="justify-center"  data-qa="accountmandates-card-fwmmy6">
                        <v-card-title class="justify-center text-subtitle-1 font-weight-bold" data-qa="accountmandates-card-title-d7ikvg">
                          {{ text.areYouSure }}
                        </v-card-title>
                        <v-card-text class="text-caption pb-0" data-qa="accountmandates-card-text-31czd">
                          {{ text.youCantUndo }}
                        </v-card-text>
                        <v-card-actions class="justify-center" data-qa="accountmandates-card-actions-w79za">
                          <v-btn text class="px-2 py-4 text-capitalize"
                            @click="menu[index] = false" data-qa="accountmandates-btn-q835r">
                            {{ text.no }}
                          </v-btn>
                          <v-btn dark class="px-2 py-4 text-capitalize"
                            :color="primaryColor"
                            @click="continueDelete(item)" data-qa="accountmandates-btn-ldkods">
                            {{ text.yes }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </template>

                  <!-- No Data -->
                  <template v-slot:no-data>
                    <v-container data-qa="accountmandates-container-y3jfe">
                      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="accountmandates-flex-4b3p3">
                        <v-icon x-large class="mr-2" color="#0000004A" data-qa="accountmandates-icon-tbk51">
                          mdi-file-account-outline
                        </v-icon>
                      </v-flex>
                      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="accountmandates-flex-4t8nd">
                        <font color="black" class="font-weight-bold text-h5">
                          {{ $t('accountMandates.errorMsg.noMandateFound') }}
                        </font>
                      </v-flex>
                      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="accountmandates-flex-kc0sib">
                        <font color="gray" class="justify-center">
                          {{ $t('accountMandates.info.add') }}
                        </font>
                      </v-flex>
                      <v-btn
                          :color="primaryColor"
                          @click="addPaymentMandate()"
                          dark
                          class="mb-2 text-capitalize font-weight-bold py-2 px-4"
                         data-qa="accountmandates-btn-2rxwwa">
                          <v-icon left class="material-symbols-outlined" size="18px" data-qa="accountmandates-icon-z4i247">
                            add
                          </v-icon>
                          {{ $t('accountMandates.button.addBtn') }}
                        </v-btn>
                    </v-container>
                  </template>
                </v-data-table>
              </template>
                  <v-flex
                    v-if="!isAccountSelected"
                    xs12 sm12 md8 lg9 xl8
                    class="pl-4" data-qa="accountmandates-flex-10jhto">
                  </v-flex>
                  <v-row v-if="!isAccountSelected" no-gutters justify="center" class="ma-6 ml-0" data-qa="accountmandates-row-dssx5y">
                    <div outlined class="text-center pa-6 font-weight-bold" color="#FAFAFA" data-qa="accountmandates-div-x6cfwq">
                    <v-icon x-large :color="primaryColor" class="pb-3" data-qa="accountmandates-icon-kal84x">mdi-account-search-outline</v-icon>
                      <p v-if="!isAccountSelected" :class="{'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }" data-qa="accountmandates-p-ul3y7">
                        {{ $t("accountMandates.info.select") }}
                      </p>
                    </div>
                  </v-row>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <Modal 
      v-if="showAccountMandatesUnSavedWarning || isLeavingRoute"
      :config="getModalConfig(warningAction)"
      @btn2Action="warningAction === 'unsaved' ? continueAction() : warningAction === 'changeAccount' ? continueAccChange() : warningAction === 'leave' ? proceedLeave() : cancelAction()"
      @btn1Action="warningAction === 'leave' ? cancelLeave() : cancelAction()">
    </Modal>

    <Modal
      v-if="showNoMandateDefinedWarning"
      :config="getModalConfig(warningAction)"
      @btn1Action="cancelAction()">
    </Modal>

    <!-- OTP Component -->
    <Modal
      v-if="otpConfig.enabled"
      :config="otpConfig"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="accountmandates-span-bdttcl">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>

    <!-- Save Mandates Confirmation -->
    <ConfirmSaveMandates
      v-show="confirmFormData.showConfimModal"
      :config="confirmFormData"
    />
  </v-flex>

</template>

<script>
import '@/styles/pages/accountMandates.scss'
import event from '@/util/event'
import _ from 'lodash'
import commonService from '@/service/commonService.js'
import AddPaymentMandate from './AddPaymentMandate.vue'
import OtpInput from '@/components/common/OtpInput.vue'

export default {
  name: 'AccountMandates',
  components: {
    OtpInput,
    AddPaymentMandate,
    'dob-snackbar': () => import('@/components/DOB-Snackbar/DobSnackbar.vue'),
    Modal: () => import('@/components/common/Modal.vue'),
    ConfirmSaveMandates: () => import('@/views/mandates/ConfirmSaveMandates.vue')
  },
  data () {
    return {
      to: null,
      disableSaveBtn: true,
      isLeavingRoute: false,
      radioChanged: false,
      isLogout: false,
      windowWidth: window.innerWidth,
      selectedAccountNumber: '',
      serviceMode: 'SELF',
      transactionChannelId: 'DOB',
      authorizerRequiredFlag: null,
      mandateRequiredFlag: null,
      mandateDefinition: {},
      hasPaymentMandates: false,
      isPristine: true,
      hasMandates: false,
      isAccountSelected: false,
      showAccountMandatesSaveWarning: false,
      showAccountMandatesUnSavedWarning: false,
      showNoMandateDefinedWarning: false,
      excludedAccountStatus: ['DORMANT', 'DEACTIVATED', 'INACTIVE', 'BLOCKED', 'STOPPED', 'CLOSED'],
      excludedRelatedType: ['Enterprise@Subsidary', 'Enterprise@ParentCompany', 'SUBSIDIARY COMPANY@PARENT COMPANY', 'PARENT COMPANY@SUBSIDIARY COMPANY'],
      warningAction: '',
      prevSelectedAccNumber: {},
      accountTypes: [],
      casaAccounts: [],
      receivedData: {},
      mandates: {},
      existingMandates: [],
      relatedPartyList: [],
      corporateId: JSON.parse(sessionStorage.getItem('corporateId')),
      showAddPaymentMandate: false,
      mandatesInfo: '',
      selectedMandate: {},
      headers: [],
      showOTPScreen: false,
      otpConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      enableOTPForAccountMandate: this.$appSettings.defaultConfigurations.enableOTPForAccountMandate,
      confirmFormData: {
        showConfimModal: false
      },
      snackbar: {
        icon: '',
        title: '',
        mode: 'multi-line',
        timeout: 4000,
        text: '',
        reason: [],
        visible: false,
        color: '',
        top: true,
        right: true,
        bottom: false,
        left: false,
        vertical: false,
        horizontal: true,
        multiLine: true
      },
      selectedMandateForDelete: null,
      menu: [],
      paymentTypeList: this.$appSettings.defaultConfigurations.accountMandatePaymentTypeList,
      accountTypeMapping: {
        SVGS: this.$t('termDepositActions.listAC.savingsLabel'),
        CACC: this.$t('termDepositActions.listAC.currentLabel'),
        TXSV: this.$t('termDepositActions.listAC.cashIsaLabel'),
        TXNA: this.$t('termDepositActions.listAC.taxNoticeLabel'),
        TXFR: this.$t('termDepositActions.listAC.txfrCashIsaLabel'),
        TXEA: this.$t('termDepositActions.listAC.txeaCashIsaLabel')
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  async created () {
    this.isLeavingRoute = false
    this.casaAccounts = await commonService.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))

    this.getPartyNames()
    event.$on('mandatePristineLogout', (arg) => {
      this.isLogout = arg
    })
    event.$on('verifyOTP', args => {
      this.otpConfig.enabled = true
    })
    event.$on('IS_OTP_VALID', (val) => {
      if (!this.showAddPaymentMandate) {
        if (val && this.otpConfig.enabled) {
          this.otpConfig.enabled = false
        }
        if (this.selectedMandateForDelete) {
          this.deleteMandate()
        } else {
          this.handleSave()
        }
      }
    })
    event.$on('mandatePristineSave', (arg) => {
      this.isPristine = true
    })
  },
  methods: {
    onOtpModalClose () {
      this.showOTPScreen = false
      this.otpConfig.enabled = false
      this.otpConfig.enableSave = true
      this.selectedMandateForDelete = null
    },
    setFlowValues () {
      if (Object.keys(this.mandateDefinition).length > 0 && (this.mandateDefinition.authorizerRequiredFlag !== this.authorizerRequiredFlag || this.mandateDefinition.mandateRequiredFlag !== this.mandateRequiredFlag)) {
        this.isPristine = false
        this.disableSaveBtn = false
        this.radioChanged = true
      }
    },
    resetFieldsAndTexts () {
      this.hasPaymentMandates = false
      this.radioChanged = false
    },
    addPaymentMandate () {
      this.mandatesInfo = {
        account: this.selectedAccountNumber,
        mandateDetails: this.mandates.mandateDetails,
        initiatorList: this.relatedPartyList,
        mandateRequiredFlag: this.mandateDefinition.mandateRequiredFlag,
        authorizerRequiredFlag: this.mandateDefinition.authorizerRequiredFlag,
        transactionChannelId: this.transactionChannelId,
        serviceMode: this.serviceMode
      }
      this.isPristine = false

      if (this.radioChanged) {
        this.showAccountMandatesUnSavedWarning = true
        this.warningAction = 'unsaved'
      } else if (this.mandateDefinition.mandateRequiredFlag === null || this.mandateDefinition.authorizerRequiredFlag === null) {
        this.showNoMandateDefinedWarning = true
        this.warningAction = 'noMandate'
      } else {
        this.showAddPaymentMandate = true
      }
    },
    setHeaders () {
      this.headers = [
        {
          text: this.$t('accountMandates.label.headers.paymenInitiator'),
          align: 'start',
          sortable: true,
          value: 'initiatorName',
          class: 'deep-purple--text'
        },
        {
          text: this.$t('accountMandates.label.headers.paymentType'),
          value: 'transactionCodeDesc',
          class: 'deep-purple--text'
        },
        {
          text: this.$t('accountMandates.label.headers.minAmt'),
          value: 'amountRangeFrom',
          class: 'deep-purple--text'
        },
        {
          text: this.$t('accountMandates.label.headers.maxAmt'),
          value: 'amountRangeTo',
          class: 'deep-purple--text'
        },
        {
          text: this.$t('accountMandates.label.headers.actions'),
          value: 'actions',
          sortable: false,
          class: 'deep-purple--text'
        }
      ]
    },
    receiveData () {
      this.showAddPaymentMandate = false
      this.getMandates()
      this.disableSaveBtn = false
    },
    editItem (mandateItem) {
      this.selectedMandate = mandateItem
      this.mandatesInfo = this.getMandateInfo(mandateItem)
      this.mandatesInfo.editMode = true
      this.mandatesInfo.mandateDetails = this.mandates.mandateDetails.filter(
        (item) => item !== mandateItem
      )
      this.isPristine = false
      if (this.radioChanged) {
        this.showAccountMandatesUnSavedWarning = true
        this.warningAction = 'unsaved'
      } else {
        this.showAddPaymentMandate = true
      }
    },
    copy (item) {
      this.mandatesInfo = this.getMandateInfo(item)
      this.mandatesInfo.copyMode = true
      this.mandatesInfo.mandateDetails = this.mandates.mandateDetails
      this.isPristine = false
      if (this.radioChanged) {
        this.showAccountMandatesUnSavedWarning = true
        this.warningAction = 'unsaved'
      } else {
        this.showAddPaymentMandate = true
      }
    },
    getMandateInfo (item) {
      return {
        account: this.selectedAccountNumber,
        detailId: item.detailId,
        initiator: item.initiator,
        transactionCode: item.transactionCode,
        minAmount: item.amountRangeFrom,
        maxAmount: item.amountRangeTo,
        approvers: this.approverMap(item),
        initiatorList: this.relatedPartyList,
        mandateRequiredFlag: this.mandateDefinition.mandateRequiredFlag,
        authorizerRequiredFlag: this.mandateDefinition.authorizerRequiredFlag,
        transactionChannelId: this.transactionChannelId,
        serviceMode: this.serviceMode
      }
    },
    approverMap (item) {
      const approvers = []
      for (let i = 1; i <= 9; i++) {
        approvers.push({
          approver: item[`authorizer${i}`],
          condition: (item[`condition${i}`] === 'AND' || item[`condition${i}`] === 0) ? 0 : 1
        })
      }
      return approvers
    },
    emitSaveFlow () {
      if (this.enableOTPForAccountMandate) {
        this.showOTPScreen = true
        this.otpConfig.enabled = true
        this.showAccountMandatesSaveWarning = false
      } else {
        this.handleSave()
      }
    },
    handleSave () {
      const mandatesBody = {
        transactionChannelId: this.transactionChannelId,
        serviceMode: this.serviceMode,
        accountId: this.selectedAccountNumber.value,
        mandateRequiredFlag: this.mandateRequiredFlag,
        authorizerRequiredFlag: this.authorizerRequiredFlag,
        mandateDetails: []
      }
      if (!this.mandates.causes) {
        this.hasMandates = true
      }
      const requestBody = mandatesBody
      if (!this.hasMandates) {
        // Call POST API
        const response = this.postMandate(requestBody)
        this.getFormData(response)
      } else {
        // call PUT API
        const response = this.putMandate(requestBody)
        this.getFormData(response)
      }
    },
    async postMandate (body) {
      const response = await commonService.saveMandates(this.selectedAccountNumber.value, this.serviceMode, body)
      if (!response.causes) {
        this.isPristine = true
        this.radioChanged = false
      }
      return response
    },
    async putMandate (body) {
      const response = await commonService.amendMandates(body)
      if (!response.causes) {
        this.isPristine = true
        this.radioChanged = false
      }
      return response
    },
    handleMandatesSaveCancel () {
      this.showAccountMandatesSaveWarning = false
    },
    handleMandatesDiscard () {
      this.$router.push('/home')
    },
    accountChange () {
      if (this.radioChanged) {
        this.showAccountMandatesUnSavedWarning = true
        this.warningAction = 'changeAccount'
      } else {
        this.getMandates()
      }
    },
    getMandates () {
      if (this.selectedAccountNumber) {
        this.isAccountSelected = true
        this.getMandateDetails()
      }
    },
    handleMandatesSaveContinue () {
      if (this.enableOTPForAccountMandate) {
        this.showOTPScreen = true
        this.otpConfig.enabled = true
        this.showAccountMandatesSaveWarning = false
      } else {
        this.handleSave()
      }
    },
    async getFormData (respData) {
      this.confirmFormData = {
        showConfimModal: false
      }
      if (!respData.causes) {
        this.confirmFormData.showConfimModal = true
        this.confirmFormData.action = 'success'
        this.mandateDefinition = {
          mandateRequiredFlag: this.mandateRequiredFlag,
          authorizerRequiredFlag: this.authorizerRequiredFlag
        }
      } else {
        this.confirmFormData.action = 'fail'
        this.confirmFormData.showConfimModal = true
        const uniqueCode = [...new Map(respData.causes.map((item) => [item.code, item])).values()]
        this.confirmFormData.causes = uniqueCode
      }
    },
    async getMandateDetails () {
      this.resetFieldsAndTexts()
      this.setHeaders()
      const prevAcc = this.selectedAccountNumber
      this.prevSelectedAccNumber = prevAcc
      const serviceMode = this.serviceMode
      const accountId = this.selectedAccountNumber.value
      let response = await commonService.getMandates(serviceMode, accountId)

      if (response.mandateDetails) {
        response.mandateDetails = response.mandateDetails.map(detail => ({
          ...detail,
          transactionCodeDesc: this.paymentTypeList.find(item => item.value === detail.transactionCode)?.text || detail.transactionCode,
          amountRangeFromWithCurrency: this.formatAmount(detail.amountRangeFrom),
          amountRangeToWithCurrency: this.formatAmount(detail.amountRangeTo)
        }))
      }

      if (response.causes && response.causes[0].code === 'FECNMD-000000') {
        // no account mandates and payment mandates yet
        this.disableSaveBtn = true
        this.existingMandates = this.mandates = response
        this.authorizerRequiredFlag = null
        this.mandateRequiredFlag = null
        this.mandateDefinition = {
          mandateRequiredFlag: null,
          authorizerRequiredFlag: null
        }
      } else if (response.causes && response.causes[0].code === 'FECNMD-000008') {
        this.existingMandates = this.mandates = response
        this.authorizerRequiredFlag = null
        this.mandateRequiredFlag = null
        this.mandateDefinition = {
          mandateRequiredFlag: null,
          authorizerRequiredFlag: null
        }
      } else {
        this.disableSaveBtn = true

        if (response.authorizerRequiredFlag || response.mandateRequiredFlag) {
          this.authorizerRequiredFlag = response.authorizerRequiredFlag
          this.mandateRequiredFlag = response.mandateRequiredFlag
          this.mandateDefinition = {
            mandateRequiredFlag: response.mandateRequiredFlag,
            authorizerRequiredFlag: response.authorizerRequiredFlag
          }
        }

        this.existingMandates = this.mandates = response

        if (response.mandateDetails.length > 0) {
          this.hasPaymentMandates = true
        }

        while (response?.links?.next) {
          const nextLink = response.links.next.href
          const nextItems = nextLink.slice(nextLink.indexOf('size'))
          response = await commonService.getMandates(serviceMode, accountId, nextItems)
          response.mandateDetails.forEach((mandate) => {
            mandate.transactionCodeDesc = this.paymentTypeList.find(item => item.value === mandate.transactionCode)?.text || mandate.transactionCode
            mandate.amountRangeFromWithCurrency = this.formatAmount(mandate.amountRangeFrom)
            mandate.amountRangeToWithCurrency = this.formatAmount(mandate.amountRangeTo)
            this.mandates.mandateDetails.push(mandate)
          })
        }

        this.setInitiatorNames()
      }
    },
    async getPartyNames () {
      const response = await commonService.getCustomerDetails(this.corporateId)
      let paymentInitiatorList = response.basicDetails.relationshipDetails.filter(item => !this.excludedRelatedType.includes(item.relationshipType))

      paymentInitiatorList.forEach(item => {
        item.relationshipType = item.relationshipType
          .replace('@', '/')
          .toLowerCase()
          .replace(/\/(.)/g, (_, char) => char.toUpperCase())
          .replace(/(^[a-z])/, (match) => match.toUpperCase())
          .split(/(?=[A-Z])/)
          .join('/')
      })
      paymentInitiatorList = _.filter(paymentInitiatorList, party => {
        if (!this.excludedRelatedType.includes(party.relationshipType)) {
          this.relatedPartyList.push({
            text: party.relatedPartyName,
            value: party.relatedPartyId,
            type: party.relationshipType
          })
        }
      })
    },
    setInitiatorNames () {
      if (this.mandates.mandateDetails) {
        this.mandates.mandateDetails.forEach(item => {
          this.relatedPartyList.forEach(party => {
            if (item.initiator === party.value) {
              item.initiatorName = party.text
              item.relationType = party.type
            }
          })
        })
      }
      this.mandates.mandateDetails = this.mandates.mandateDetails.filter(item => item.initiatorName && item.relationType)
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    cancelAction () {
      this.showAccountMandatesUnSavedWarning = false
      this.showNoMandateDefinedWarning = false
      this.selectedAccountNumber = this.prevSelectedAccNumber
    },
    continueAction () {
      this.showAccountMandatesUnSavedWarning = false

      if (this.mandateDefinition.mandateRequiredFlag === null || this.mandateDefinition.authorizerRequiredFlag === null) {
        this.showNoMandateDefinedWarning = true
        this.warningAction = 'noMandate'
      } else {
        this.showAddPaymentMandate = true
      }
    },
    continueAccChange () {
      this.showAccountMandatesUnSavedWarning = false
      this.getMandates()
    },
    continueDelete (item) {
      if (this.enableOTPForAccountMandate) {
        this.showOTPScreen = true
        this.otpConfig.enabled = true
        this.selectedMandateForDelete = {
          accountId: this.selectedAccountNumber.value,
          initiator: item.initiator,
          transactionCode: item.transactionCode,
          amountRangeFrom: item.amountRangeFrom,
          amountRangeTo: item.amountRangeTo
        }
        return
      }
      this.deleteMandate()
    },
    onResize () {
      this.windowWidth = window.innerWidth
    },
    async deleteMandate () {
      const resp = await commonService.deleteMandates(this.selectedMandateForDelete)
      if (resp?.causes?.length) {
        this.snackbar = {
          title: 'Delete mandate failed',
          text: 'The deletion of payment mandate failed. Please try again',
          reason: [],
          visible: true,
          color: 'error'
        }
      } else {
        this.snackbar = {
          title: 'Mandate Deleted Successfully',
          text: 'The mandate had been deleted successfully.',
          reason: [],
          visible: true,
          color: 'success'
        }
      }
      this.selectedMandateForDelete = null
      this.getMandates()
    },
    formatAmount (amount) {
      return this.$formatter.currency.format(amount, this.selectedAccountNumber.currency)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.isPristine) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else {
        this.to = to
        this.isLeavingRoute = true
        this.warningAction = 'leave'
      }
    } else {
      next()
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTPForAccountMandate && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  },
  beforeDestroy () {
    event.$off('verifyOTP')
    event.$off('IS_OTP_VALID')
    window.removeEventListener('resize', this.onResize)
  },
  computed: {
    text () {
      return {
        yes: this.$t('common.yes'),
        no: this.$t('common.no'),
        youCantUndo: this.$t('common.youCantUndo'),
        areYouSure: this.$t('common.areYouSure')
      }
    },
    accountList () {
      if (!this.casaAccounts?.items) return []

      return this.casaAccounts.items
        .filter(item => this.config.validAccountTypes.includes(item.accountType) && !this.excludedAccountStatus.includes(item.accountStatus))
        .map(item => ({
          text: `${this.accountTypeMapping[item.accountType]} - ${item.accountId}`,
          value: item.accountId,
          currency: item.currency
        }))
    },
    config () {
      return {
        validAccountTypes: this.$appSettings.defaultConfigurations.accountMandates.validAccountTypes
      }
    },
    getModalConfig () {
      return (action) => {
        const actionMap = {
          common: {
            title: this.$t('accountMandates.label.unsaveChanges'),
            subtitle: this.$t('accountMandates.warning.warnDiscard'),
            btn2Label: this.$t('accountMandates.button.onDiscard'),
            btn1Label: this.$t('accountMandates.button.onContEdit')
          },
          noMandate: {
            title: this.$t('accountMandates.label.noMandateDefinition'),
            subtitle: this.$t('accountMandates.warning.warnNoMandateDefinition'),
            btn1Label: this.$t('accountMandates.button.ok')
          }
        }

        if (['unsaved', 'changeAccount', 'leave'].includes(action)) {
          return {
            enabled: this.showAccountMandatesUnSavedWarning || this.isLeavingRoute,
            persistent: true,
            width: 500,
            ...actionMap.common
          }
        } else if (action === 'noMandate') {
          return {
            enabled: this.showNoMandateDefinedWarning,
            persistent: true,
            width: 500,
            ...actionMap.noMandate
          }
        }
      }
    }
  }
}
</script>

<style>
.small-radio i {
  font-size: 19px;
}
.small-radio label {
  font-size: 14px;
  padding-left: 0px;
  margin-left: -4px;
}
.small-radio .v-radio {
  padding: 0px;
}
.small-radio [class*="__ripple"] {
  left: 0;
}
</style>
